import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "opacity-100 transition-opacity duration-300 ease-in-out group-data-[state=collapsed]:opacity-0" }
const _hoisted_2 = { class: "font-normal opacity-100 transition-opacity duration-300 ease-in-out group-data-[state=collapsed]:opacity-0" }
const _hoisted_3 = { class: "font-normal opacity-100 transition-opacity duration-300 ease-in-out group-data-[state=collapsed]:opacity-0" }

import {
        SidebarMenu,
        SidebarMenuButton,
        SidebarMenuItem,
        useSidebar,
    } from '@/components/ui/sidebar';
    import {
        DropdownMenu,
        DropdownMenuContent,
        DropdownMenuTrigger,
        DropdownMenuItem,
    } from '@/components/ui/dropdown-menu';
    import { type NavItem, type SharedData } from '@/types';
    import { Link, usePage } from '@inertiajs/vue3';
    import { ChevronsUpDown } from 'lucide-vue-next';
    import { HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'reka-ui';
    import { SIDEBAR_WIDTH } from '@/components/ui/sidebar/utils';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'NavMenu',
  props: {
    items: {}
  },
  setup(__props: any) {

    

    const page = usePage<SharedData>();
    const { isMobile, state, setOpen } = useSidebar();

    const { t } = useI18n();

    const isActive = (item: NavItem) => {
        const path = `${window.location.origin}/${item.group}`;
        return page.props.ziggy.location.startsWith(path);
        // return page.props.ziggy.location.startsWith(item.href);
    };

    const linkComponent = (item: NavItem) => {
        if (item.component) {
            return item.component;
        }
        if (item.external) {
            return 'a';
        }
        return Link;
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SidebarMenu), null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createBlock(_unref(SidebarMenuItem), {
          key: item.title
        }, {
          default: _withCtx(() => [
            (item.subItems && _unref(isMobile))
              ? (_openBlock(), _createBlock(_unref(DropdownMenu), { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DropdownMenuTrigger), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SidebarMenuButton), {
                          class: "transition-all duration-300 ease-in-out group-data-[collapsible=icon]:opacity-20 group-data-[collapsible=icon]:data-[active=true]:bg-transparent group-data-[collapsible=icon]:data-[active=true]:opacity-100",
                          "is-active": isActive(item)
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon))),
                            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)(item.title)), 1),
                            (_unref(state) === 'expanded')
                              ? (_openBlock(), _createBlock(_unref(ChevronsUpDown), {
                                  key: 0,
                                  class: "ml-auto size-4"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["is-active"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(DropdownMenuContent), {
                      class: "bg-sidebar w-(--reka-dropdown-menu-trigger-width) min-w-[300px] rounded-none border-none",
                      side: "bottom",
                      align: "start",
                      "side-offset": 7
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subItems, (subItem) => {
                          return (_openBlock(), _createBlock(_unref(DropdownMenuItem), {
                            key: subItem.title,
                            "as-child": true,
                            class: "text-sidebar-foreground hover:text-sidebar-accent-foreground! h-12 hover:bg-transparent!"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Link), {
                                class: "block w-full",
                                href: subItem.href,
                                as: "button"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)(subItem.title)), 1)
                                ]),
                                _: 2
                              }, 1032, ["href"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : (item.subItems)
                ? (_openBlock(), _createBlock(_unref(HoverCardRoot), {
                    key: 1,
                    "open-delay": 0,
                    "close-delay": 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(HoverCardTrigger), { "as-child": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(SidebarMenuButton), {
                            class: "data-[state=open]:text-accent transition-all duration-300 ease-in-out group-data-[collapsible=icon]:opacity-20 group-data-[collapsible=icon]:hover:opacity-100 group-data-[collapsible=icon]:data-[active=true]:bg-transparent group-data-[collapsible=icon]:data-[active=true]:opacity-100 data-[state=open]:opacity-100",
                            "is-active": isActive(item),
                            "data-location": _unref(page).props.ziggy.location,
                            "data-href": item.href
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon))),
                              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)(item.title)), 1),
                              (_unref(state) === 'expanded')
                                ? (_openBlock(), _createBlock(_unref(ChevronsUpDown), {
                                    key: 0,
                                    class: "ml-auto size-4"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["is-active", "data-location", "data-href"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_unref(HoverCardPortal), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(HoverCardContent), {
                            class: "bg-sidebar z-50 min-w-(--sidebar-width) rounded-none border-none pl-[7px] data-[state=open]:transition-all",
                            style: _normalizeStyle({
                            '--sidebar-width': _unref(SIDEBAR_WIDTH),
                        }),
                            side: "right",
                            align: "start"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subItems, (subItem) => {
                                return (_openBlock(), _createBlock(_unref(Link), {
                                  key: subItem.title,
                                  class: "focus:text-accent text-sidebar-foreground hover:text-sidebar-accent-foreground! relative flex h-12 w-full cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none hover:bg-transparent! data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
                                  href: subItem.href,
                                  as: "button"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)(subItem.title)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["href"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["style"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createBlock(_unref(SidebarMenuButton), {
                    key: 2,
                    "as-child": "",
                    class: "transition-all duration-300 ease-in-out group-data-[collapsible=icon]:opacity-20 group-data-[collapsible=icon]:hover:opacity-100 group-data-[collapsible=icon]:data-[active=true]:bg-transparent group-data-[collapsible=icon]:data-[active=true]:opacity-100",
                    "is-active": isActive(item),
                    tooltip: _unref(t)(item.title)
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(linkComponent(item)), {
                        href: item.href,
                        target: item.external ? '_blank' : '',
                        item: item
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon))),
                          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)(item.title)), 1)
                        ]),
                        _: 2
                      }, 1032, ["href", "target", "item"]))
                    ]),
                    _: 2
                  }, 1032, ["is-active", "tooltip"]))
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})